import { render } from "./CertsPage.vue?vue&type=template&id=5c64a8fe"
import script from "./CertsPage.vue?vue&type=script&lang=js"
export * from "./CertsPage.vue?vue&type=script&lang=js"

import "./CertsPage.vue?vue&type=style&index=0&id=5c64a8fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__